let btnInclui = document.querySelector("#pass-inclui");

if (btnInclui) {
  let btnNaoInclui = document.querySelector("#pass-naoinclui");
  let btnDicas = document.querySelector("#pass-dicas");
  let btnInfo = document.querySelector("#pass-info");

  let textoInclui = document.querySelector(".pass-inclui-txt");
  let textoNaoInclui = document.querySelector(".pass-naoinclui-txt");
  let textoDicas = document.querySelector(".pass-dicas-txt");
  let textoInfo = document.querySelector(".pass-info-txt");

  function ativaTxt(e) {
    let passTextos = document.querySelectorAll(".pass-texto");
    let passBtns = document.querySelectorAll(".pass-btns");

    passTextos.forEach((passTexto) => {
      passTexto.classList.remove("active");
    });

    passBtns.forEach((passBtn) => {
      passBtn.classList.remove("active");
    });

    e.classList.add("active");
  }

  btnInclui.addEventListener("click", function () {
    ativaTxt(textoInclui);
    btnInclui.classList.add("active");
  });

  btnNaoInclui.addEventListener("click", function () {
    ativaTxt(textoNaoInclui);
    btnNaoInclui.classList.add("active");
  });

  btnDicas.addEventListener("click", function () {
    ativaTxt(textoDicas);
    btnDicas.classList.add("active");
  });

  btnInfo.addEventListener("click", function () {
    ativaTxt(textoInfo);
    btnInfo.classList.add("active");
  });
}
